import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import PartnerDetail from '@components/obsolete/partners/PartnerDetail.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

const PartnerDetailPage = () => {
  const { id } = useParams();
  const { t } = useTranslation('common');
  return (
    <>
      {id && (
        <ResponsiveLayout title={t(`[id].partnerDetail`, `Detail partnera`)}>
          {/*
        // @ts-ignore*/}
          <Card>
            <PartnerDetail partnerId={id as string} />
          </Card>
        </ResponsiveLayout>
      )}
    </>
  );
};

export default withAuthenticationRequired(PartnerDetailPage);
